import * as links from '../../../constants/links';

export default [
  [`^/?${links.LINK_ADMIN}/?$`, {
    title: 'Fiat to Crypto',
    main: require('../../../components/pages/Admin/Dashboard/'),
    v2: 1,
  }],
  [`^/?${links.LINK_ADMIN_RETAILERS}/?$`, {
    title: 'Retailers',
    main: require(`../../../components/pages/Admin/Retailers`),
    v2: 1,
  }],
  [`^/?${links.LINK_ADMIN_RETAILER_DETAILS}/([^/]+):id$`, {
    title: 'Retailers',
    main: require(`../../../components/pages/Admin/RetailerPage`),
    v2: 1,
  }],
  [`^/?${links.LINK_ADMIN_TRANSACTIONS}/?$`, {
    title: 'Transactions',
    main: require('../../../components/pages/Admin/Transactions'),
    v2: 1,
  }],
  [`^/?${links.LINK_ADMIN_TRANSACTIONS_DETAILS}/([^/]+):id$`, {
    title: 'Transactions',
    main: require('../../../components/pages/Admin/TransactionPage'),
    v2: 1,
  }]
];
